import { resolveStaffModuleAccess } from './staffModulePermissions';

export const CARGAR_NUEVO_EMPLEADO_MODULE_ID = 'cargar_nuevo_empleado';

function isCompanyCargarNuevoEmpleadoGranted(companyPerms) {
  if (companyPerms === undefined) return false;
  const row = (companyPerms || []).find((p) => p.moduleId === CARGAR_NUEVO_EMPLEADO_MODULE_ID);
  return row?.hasAccess === true;
}

export function resolveCargarNuevoEmpleadoAccess(
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
) {
  if (!isCompanyCargarNuevoEmpleadoGranted(companyPerms)) return false;
  return resolveStaffModuleAccess(
    CARGAR_NUEVO_EMPLEADO_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}
